import styled, { css } from 'styled-components';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';

export const HomeLoansDashboardContentContainer = styled.div<{
    version: HEADER_VERSIONS;
}>`
    ${({ version }) => css`
        display: flex;
        line-height: 40px;
        @media (max-width: ${getBreakpointsForHeaderVersion(version).DESKTOP - 1}px) {
            margin-top: 16px;
            border: 1px solid #e6e6e6;
            padding: 16px;
            background: #fff;
        }
    `}
`;
